module.exports = __webpack_public_path__ + "img/weixinDownloadAndroid.38d647dd.png";